export class PhotoVariation {
    constructor() {
        this.storagePath = "";
        this.width = undefined;
        this.height = undefined;
        this.id = "";
    }
    static load(source) {
        var loaded = new PhotoVariation();
        if (!source) {
            return loaded;
        }
        loaded.storagePath = source.storagePath;
        loaded.width = source.width;
        loaded.height = source.height;
        return loaded;
    }
}
//# sourceMappingURL=photo-variation.js.map